export default class PlayTtsAudio {
    // 普通播放状态监视器
    time = null
    // 有背景音乐播放状态监视器
    bg_time = null
    // tts播放地址
    src = ""
    constructor() {
        // tts播放器对象
        this.innerAudioContext = new Audio();
        // 背景音乐播放器对象
        this.bg_innerAudioContext = new Audio();
        this.bg_innerAudioContext.loop = true
    }
    // 常规tts播放
    play(url,callback) {
        this.src = url;
        this.innerAudioContext.src = url;
        this.innerAudioContext.play();
        this.monitorPlay(callback)
    };
    // 有背景音乐播放
    haveBgPlay(url, bg_src, bgdelaytime, textdelaytime) {
        /*
        url:tts播放地址
        bg_src：背景音乐播放地址
        bgdelaytime：背景音乐续博时长
        textdelaytime：文本播报延迟时长
        */
        this.src = url
        this.bg_innerAudioContext.src = bg_src
        this.bg_innerAudioContext.play()
        setTimeout(() => {
            this.src = url;
            this.innerAudioContext.src = url;
            this.innerAudioContext.play();
            this.monitorHaveBgPlay(bgdelaytime)
        }, (parseInt(textdelaytime)) * 1000)
    }
    // 停止播放
    stop() {
        this.src = "";
        this.innerAudioContext.pause();
        this.innerAudioContext.src = '';
        this.bg_innerAudioContext.pause();
        this.bg_innerAudioContext.src = '';
    }
    // 监听播放停止
    monitorPlay(callback) {
        this.time = setInterval(() => {
            if (this.innerAudioContext.ended) {
                this.src = ""
                clearInterval(this.time)
                callback()
            }
        }, 1000)
    }
    // 监听有背景音乐的tts播放停止事件
    monitorHaveBgPlay(bgdelaytime) {
        this.bg_time = setInterval(() => {
            if (this.innerAudioContext.ended) {
                this.stopBgMusic(bgdelaytime)
                clearInterval(this.bg_time)
            }
        }, 1000)
    }
    // 停止背景音乐播放
    stopBgMusic(bgdelaytime) {
        setTimeout(() => {
            this.bg_innerAudioContext.pause()
            this.bg_innerAudioContext.src = ''
            this.src = ""
        }, (parseInt(bgdelaytime)) * 1000)
    }
    // 设置背景音乐音量
    setBgVolume(val) {
        // Aduio对象的音量取值范围为(0~1)
        this.bg_innerAudioContext.volume = parseInt(val) / 100
    }
}



// WEBPACK FOOTER //
// ./src/utils/PlayTtsAudio.js